// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import VueJsonp from 'vue-jsonp'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview, { mainClass: "photoPreviewPlug" })

import { findData } from "@/utils/globalvarFind.js";

Vue.config.productionTip = false;

Vue.prototype.$pems = store.getters;
Vue.prototype.$findData = findData;
Vue.use(VueJsonp)
//Vue.prototype.$push = { initPush, pushSend, pushOpen, onlisten, close };
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js